import { Component, OnDestroy } from '@angular/core';
import { LoaderService } from '../shared/services/loader-service/loader.service';
import { Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnDestroy {
  public isLoading = false;
  private destroy$ = new Subject<void>();

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoading) => {
        this.isLoading = isLoading;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
